module.exports = __webpack_public_path__ + "static/img/service_introduce_5863_zh_h5.c2fdb43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5863_zh_h5.png
// module id = 6EbK
// module chunks = 34